import React, { useState } from 'react';

import ClickableIcon from '~components/ClickableIcon';
import { faHourglass, faRefresh } from '~components/icon';
import { Row } from '~components/table-view';

import { refreshItemMeta } from './supplierInvoiceItems';

interface ComponentProps {
  row: Row;
  mode: 'package' | 'po';
  clientId: number | undefined;
  setFormData: (updater: (prev: any) => any) => void;
}

const RefreshActionButton: React.FC<ComponentProps> = ({ row, mode, clientId, setFormData }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshRow = async (row: Row) => {
    if (isRefreshing) return;
    setIsRefreshing(true);

    try {
      const { client_budget_id, _meta } = await refreshItemMeta(row, clientId, mode);

      // Update only this specific row
      setFormData((prev) => ({
        ...prev,
        items: prev.items?.map((item: any) => (item.id === row.id ? { ...item, client_budget_id, _meta } : item)) || [],
      }));
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className="d-flex justify-content-end align-items-center gap-2">
      <ClickableIcon
        id={`${row.id}-refresh`}
        icon={isRefreshing ? faHourglass : faRefresh}
        onClick={() => refreshRow(row)}
        toolTip="Refresh"
        disabled={isRefreshing}
      />
    </div>
  );
};

export default RefreshActionButton;
